/* global window document */
const scrollToTop = () => window.scrollTo(0, 0);

const scrollToBottom = () => window.scrollTo(0, document.body.scrollHeight);

module.exports = { scrollToTop, scrollToBottom };
